import React from "react";
function AmazonRetailerMessage() {
  return (
    <span>
      We don’t price match items sold by 3rd party sellers on Amazon.{" "}
      <a
        href={`https://www.johnlewis.com/customer-services/faq/How-to-check-if-an-item-is-sold-directly-or-by-a-240924090908830`}
        rel="noopener noreferrer"
        target="_blank"
      >
        How to check
      </a>
    </span>
  );
}

export default AmazonRetailerMessage;
